import { formatSydneyDateTime } from './sydneyDateTime'

/**
 * SMR draft may expose ISO instants (parsable) or legacy AEST display strings (DD/MM/YYYY …).
 */
export function formatSmrReportDateTime(value, displayFallback) {
  if ((value == null || value === '') && displayFallback) return displayFallback
  if (value == null || value === '') return '—'
  const d = new Date(value)
  if (!Number.isNaN(d.getTime())) {
    return formatSydneyDateTime(d)
  }
  if (typeof value === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}/.test(value.trim())) return value
  return displayFallback || '—'
}
